import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Form,
  FormPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/form.scss';

export type NcFormT = React.FC<FormPropsT>;

export const NcForm: NcFormT = ({ className, ...props }) => {
  const classNames = mergeClassNameStrings('nc-form', className);

  return (
    <Form
      {...props}
      className={classNames}
      noValidate
    />
  );
};
